import React from 'react';
import DelayRender from '../Common/DelayRender'

// Translations
import translate from '../Translate.js';

// Dependencies
import { checkValidity } from '../../helpers/helpers.js'
import * as icons from '../Icons/Icons';
// Components
import SignIn from './SignIn.js';

import { LaunchDarkly, FeatureFlag } from 'react-launch-darkly';
import { config } from '../../config.js';

class AccountSession extends React.Component {
  constructor() {
    super()
    this.createProctor = this.createProctor.bind(this);
    this.handleSignup = this.handleSignup.bind(this);
    this.installSid = '';
  }

  componentWillMount() {
    this.state = {
      installSid: null,
      hasLoaded:this.getParameterByName('account') === null ? true : false,
      error: false,
      pageContent: null,
      username: null,
      password: null
    }
    // Clear out old session data
    this.props.store.SessionStore.removeLocalStorage();
    if(this.props.content === 'SignIn') {
      this.setState({
        pageContent: <SignIn {...this.props} installSid={this.state.installSid} checkValidity={checkValidity} />
      });
    }
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  createProctor() {
    this.props.store.RegisterStore.createProctor(this.handleSignup);
  }

  getInstall(account) {
    var cssId = 'accountCss'
    this.props.store.SessionStore.getInstall(account)
    .then(res => {
      this.setState({
        installSid: res.data.installSid
      });
      this.setState({
        hasLoaded: true
      });
        if (!document.getElementById(cssId) && res.data.cssUrl)
          {
            var head  = document.getElementsByTagName('head')[0];
            var link  = document.createElement('link');
            link.id   = cssId;
            link.rel  = 'stylesheet';
            link.type = 'text/css';
            link.href = res.data.cssUrl
            link.media = 'all';
            head.appendChild(link);
          }
      })
      .catch(e => {
        this.setState({
        hasLoaded: true
        });
        this.setState({
          error: true
        });

      })
  }

  handleSignup() {
    this.props.routing.push('/register')
  }

  render() {
    if(this.getParameterByName('account') && !this.state.installSid && !this.state.error) {
     this.getInstall(this.getParameterByName('account'))
    }

    const { translation } = this.props;
    const backgroundImg = 'url(./static/img/bg-sign-up.jpg)';
    const isSub = this.getParameterByName('account') && !this.state.error

    let content = isSub ?
      (<main className="page page--graphic page--pane-right" style={{backgroundImage: backgroundImg}}>
        <div className="page--graphic__content wrap">
          <img src="./static/img/logo-white.png" width="300" alt="SmarterProctoring" />

          {/* <p>{translation.intro}</p> */}
        </div>

        <div className="pane pane--right pane--fixed">
          {this.state.pageContent}
        </div>
      </main>) :
      (<div className="panel--brief" style={{marginTop:"30px"}}>
          <i className="page--error__icon"><icons.iconLock /></i>
          <div>
            <h1 className="panel__title">{translation.not_configured}</h1>
            <p>{translation.not_configured_text}</p>
          </div>
      </div>);

    return (
      <DelayRender test={this.state.hasLoaded}>

        <LaunchDarkly clientId={config.ldApiKey} user={{key: 'anonymous-user', anonymous: true}}>
          <FeatureFlag
              flagKey="maintenance-message"
              renderFeatureCallback={function(flagValue) {
                if(flagValue && typeof flagValue === 'object' && flagValue.message !== undefined){
                  // Redirect to maintenance page
                  window.location.href = `/#/maintenance`;
                  return null;
                }else{
                  return null;
                }
              }}
            />
        </LaunchDarkly>

        <div>{content}</div>
      </DelayRender>
    );
  }
}

export default translate('AccountSession')(AccountSession);


// WEBPACK FOOTER //
// ./src/app/components/Account/Session.js